<!-- @format -->

<template>
	<van-action-sheet
		v-model="show"
        :close-on-popstate="true" 
        title="用药信息"
        style="height:80vh"
	>
        <div class="cont">
            <div class="padding-lr-lg padding-lr-lg">
                <div class="drug-list">
                    <div
                        :class="`drug-list-item ${item.value === selectType ? 'active_type' : ''}`" 
                        v-for="(item,index) in typeList"
                        :key="index"
                         @click="clickDrugType(item)"
                        >{{ item.label }}</div
                    >
                </div>
                <div class="drug-item" v-for="item in drugAllList" :key="item.name">
                    <div class="drug-item-title">{{ item.name }}</div>
                    <div class="drug-list">
                        <div
                            v-for="childItem in item.list"
                            :class="`drug-list-item ${getDrugItemClass(childItem, selectValueList)}`"
                            :key="childItem.id"
                            @click="clickDrugItem(childItem)"
                            >{{ childItem.name }}</div
                        >
                    </div>
                </div>
                <div class="drug-item">
                    <div class="drug-item-title">其他药物</div>
                    <van-field
                        v-model="inputVal"
                        :disabled="isView"
                        rows="5"
                        autosize
                        type="textarea"
                        maxlength="200"
                        placeholder="请输入药品名称"
                    />
                </div>
                <div class="footer" v-if="!isView">
                    <van-button class="bottom-btn" type="primary" block @click="clickSubmit">
                        保存
                    </van-button>
                </div>
                
            </div>
        </div>
	</van-action-sheet>
</template>

<script>
	export default {
		props:{
			drugList:{
				type:Array,
				default:()=>[]
            },
            otherDrugs:{
                type:String,
                default:''
            },
            isView:{
				type:Boolean,
				default:false
			}
		},
	    data () {
	        return {
				show:false,
                page:1,
                limit:999,
                drugAllList:[],
                typeList: [
                    { label: '用药历史', value: 1 },
                    { label: '正在服用', value: 2 },
                    { label: '药物过敏史', value: 3 },
                ],
                selectType:1,
                selectValueList:[],
                finalVal:''
	        }
        },
        
        computed: {
			inputVal:{
				get(){
					return this.otherDrugs
				},
				set(val){
					this.finalVal = val
				}
			}
	    },

	    created() {

	    },

	    methods: {
            init(){
                this.show = true
                this.getDrugList(this.selectType)
                this.selectValueList = [...this.drugList]
            },
            getDrugList(type){
                this.$api.order.drugList({
                    type:type,
                    page:this.page,
                    limit:this.limit
                }).then(({data})=>{
                    this.drugAllList = data
                })
            },

            getDrugItemClass: function (item, list) {
                var classStr = ''
                if (item.name.length > 6) classStr += 'row';
                var isExist = list.some(function (val) { return val.id === item.id })
                if (isExist) classStr += ' active';
                return classStr;
            },

            clickDrugType(item){
                if(this.isView) return
                if(this.selectType === item.value) return
                this.selectType= item.value
                this.getDrugList(item.value)
            },

            clickDrugItem(item){
                if(this.isView) return
                let itemIndex = this.selectValueList.findIndex(val => val.id === item.id)
                if (itemIndex > -1) {
                    this.selectValueList.splice(itemIndex, 1)
                } else {
                    this.selectValueList.push(item)
                }
                this.getDrugItemClass(item, this.selectValueList)
            },

			clickSubmit(){
                this.show = false
                this.$emit('getDrugInfo',this.selectValueList,this.finalVal)
			}
	    }
	}
</script>

<style lang="less" scoped>
	.cont{
		padding:30px 30px 180px;
		font-size: 30px;
		line-height: 60px;
		background-color: #fff;
		box-sizing: border-box;
        .van-field {
            background-color: #F5F6F7;
            height: 250px;
            border-radius: 6px;
            padding: 24px;
            box-sizing: border-box;
            margin-bottom: 50px;
        }
    }
    .footer{
        position: fixed;
        background-color: #fff;
        width:100vw;
        padding:5vw;
        left:0;
        bottom: 0;
        border-top:1px solid #EFF0F1;
        .bottom-btn{
            width:90vw;
        }
    }
	
	.drug_list {
	   height: 70vh;
	}
	.drug-item-title {
	   font-family: PingFangSC-Medium;
	   font-size: 32px;
	   font-weight: normal;
	   line-height: normal;
	   color: #1F2329;
	   padding: 32px 0;
	}

	.drug-list {
	   display: flex;
	   flex-wrap: wrap;
	}
	.drug-list-item{
	   box-sizing: border-box;
	   width: calc((100% - 60px) / 3);
	   margin-right: 28px;
	   margin-bottom: 28px;
	   border-radius: 10px;
	   height: 100%;
	   overflow: auto;
	   text-align: center;
	   padding: 10px 0;
	   background-color: #EFF0F1;
	   border: 2px solid transparent;
	   transition: all .3s;
	}
	.drug-list-item:nth-of-type(3n){
	   margin-right: 0;
	}
	.drug-list-item.row {
	   width: calc(((100% - 60px) / 3) + ((100% - 60px) / 3) + 28px);
	}
	.drug-list-item.active_type {
	   background-color: @primary;
	   color: #fff;
	}
	.drug-list-item.active {
	   color: @primary;
	   border-color: @primary;
	   background-color: @lightPrimary;
	}
</style>
